import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    SelectChangeEvent,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type Option = {
    title: string;
    key: string;
};
const options: Option[] = [
    {
        title: "الكل",
        key: "all",
    },
    {
        title: "البوابة",
        key: process.env.REACT_APP_PORTAL_CAT_ID || "",
    },
    {
        title: "المتجر",
        key: process.env.REACT_APP_STORE_CAT_ID || "",
    },
];

type Props = {
    value: string;
    setValue: Dispatch<SetStateAction<string>>;
};
const AppFilter = ({ value, setValue }: Props) => {
    const handleChange = (e: SelectChangeEvent<string>) => {
        setValue(e.target.value);
    };
    return (
        <Box sx={{ flex: "1", minWidth: "230px" }}>
            <FormControl fullWidth>
                <InputLabel>التطبيق</InputLabel>
                <Select value={value} label="ترتيب حسب" onChange={handleChange}>
                    {options.map((option: Option) => (
                        <MenuItem value={option.key} key={option.key}>
                            {option.title}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default AppFilter;
